import React from 'react';
import { useQuery } from 'react-query';
import { useServiceClient } from 'common';
import { useConfigScopeSelectors } from 'modules/core/scopes';
import { useDefaultSettingsPayload } from 'modules/default-app-settings/containers';
import { SharedEndPoints, SharedReactQueryKey } from './query-enum';
import { IGetTextData } from './query-interfaces';

export const useGetApplicationListQuery = () => {
    const { getData } = useServiceClient();
    const currentUserDetails = useConfigScopeSelectors().selectCurrentUserDetails();
    const { getPayloadDetailsByType } = useDefaultSettingsPayload();

    const getApplicationListDetails = React.useCallback(() => (
        getData(`${SharedEndPoints.GET_APPLICATION_LIST}${currentUserDetails.userName.replace(/\\/g, '_')}`)
            .then((res) => res.json())
            .catch(() => getPayloadDetailsByType('app-list').applicationListSettings)
    ), [getData, currentUserDetails.userName, getPayloadDetailsByType]);
    return useQuery<IGetTextData>(SharedReactQueryKey.GET_APPLICATION_LIST, getApplicationListDetails);
};
